import type { PaymentsTranslations } from "@/shared/lang/interfaces/payments";

export const FORM_METHOD_FIELD_LABEL_TKEYS: Record<
  string,
  keyof PaymentsTranslations
> = {
  llaveBreB: "modal_info_field_llave_bre_b",
  numeroCelularNequi: "modal_info_field_numero_celular_nequi",
  bancoAch: "modal_info_field_banco_ach",
  tipoCuenta: "modal_info_field_tipo_cuenta",
  numeroCuenta: "modal_info_field_numero_cuenta",
  tipoDocumento: "modal_info_field_tipo_documento",
  numeroDocumento: "modal_info_field_numero_documento",
  tipoLlavePix: "modal_info_field_tipo_llave_pix",
  llavePix: "modal_info_field_llave_pix",
  clabe: "modal_info_field_clabe",
  banco: "modal_info_field_banco",
  rut: "modal_info_field_rut",
  email: "modal_info_field_email",
  numeroCci: "modal_info_field_numero_cci",
  documentoIdentidad: "modal_info_field_documento_identidad",
  numeroCelularYape: "modal_info_field_numero_celular_yape",
  numeroCelularPlin: "modal_info_field_numero_celular_plin",
  routingNumber: "modal_info_field_routing_number",
  swiftBic: "modal_info_field_swift_bic",
  direccionBanco: "modal_info_field_direccion_banco",
  emailOTelefonoZelle: "modal_info_field_email_telefono_zelle",
  iban: "modal_info_field_iban",
  tipoIdentificadorFps: "modal_info_field_tipo_identificador_fps",
  identificadorFps: "modal_info_field_identificador_fps",
  codigoChats: "modal_info_field_codigo_chats",
  idAlipay: "modal_info_field_id_alipay",
  idWechat: "modal_info_field_id_wechat",
  numeroCuentaIban: "modal_info_field_numero_cuenta_iban",
  numeroCelular: "modal_info_field_numero_celular",
  cbuCvu: "modal_info_field_cbu_cvu",
  cbu: "modal_info_field_cbu",
  cvu: "modal_info_field_cvu",
  direccionWallet: "modal_info_field_direccion_wallet",
  binancePayUid: "modal_info_field_binance_pay_uid",
  binancePayEmail: "modal_info_field_binance_pay_email",
};

export const FORM_METHOD_OPTION_LABEL_KEYS: Record<
  string,
  keyof PaymentsTranslations
> = {
  Ahorros: "form_method_option_ahorros",
  Corriente: "form_method_option_corriente",
  NIT: "form_method_option_nit",
  CC: "form_method_option_cc",
  CE: "form_method_option_ce",
  PASAPORTE: "form_method_option_pasaporte",
  PPT: "form_method_option_ppt",
  CPF: "form_method_option_cpf",
  CNPJ: "form_method_option_cnpj",
  Email: "form_method_option_email",
  Teléfono: "form_method_option_telefono",
  "Llave aleatoria": "form_method_option_llave_aleatoria",
  "ID FPS": "form_method_option_id_fps",
};
